export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PDS_BANCA_BM-17df89ec44060703dce1691aab28326a.pdf";